export const ENTITLEMENTS_SUB_TABS = {
    USER_ENTITLEMENTS: {
        name: 'user-entitlements',
        caption: 'Entitlements',
    },
    MCP_ENTITLEMENTS: {
        name: 'mcp-entitlements',
        caption: 'MCP Entitlements',
    },
    DATASET_ENTITLEMENTS: {
        name: 'dataset-entitlements',
        caption: 'Dataset Entitlements',
    },
};
